import { TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";

const MultiAutocomplete = ({ 
  value, 
  label, 
  placeholder, 
  onChange,
  options = [] ,
  hideRemoveIcon
}) => {
  console.log("options",options);
  // Ensure value is always an array
  const normalizedValue = Array.isArray(value) ? value : (value ? [value] : []);

  const handleChange = (event, newValue, reason, details) => {
onChange(event, newValue,reason,details);
    
    // Always call the original onChange
    
  };

  return (
    <div className="grid gap-1">
      <label className="text-[#000000]">
        {label}
      </label>
      <div className="bg-white">
        <Autocomplete
          multiple
          options={options}
          freeSolo
          disableCloseOnSelect
          value={normalizedValue}
            {...(hideRemoveIcon && { clearIcon: null })} 
          onChange={handleChange}
          getOptionLabel={(option) => {
            if (typeof option === 'string') return option;
            return option.label || option.value || '';
          }}
          isOptionEqualToValue={(option, value) => {
            if (typeof option === 'string' || typeof value === 'string') {
              return option === value;
            }
            return option.value === value.value;
          }}
          renderInput={(params) => (
            <TextField {...params} variant="outlined" placeholder={placeholder} />
          )}
          renderOption={(props, option) => (
            <li {...props}>
              {typeof option === 'string' ? option : option.label}
            </li>
          )}
        />
      </div>
    </div>
  );
};

export default MultiAutocomplete;